import React, { Component } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";

class venueDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
        }
        this.slider3Ref = React.createRef()
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        const { isLoading } = this.state

        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <Header />
                <main className="main-area fix">
                    {/* breadcrumb-area */}
                    <div
                        className="breadcrumb__area breadcrumb__bg"
                        data-background="assets/img/aboutUs_img.jpg"
                    >
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb__content">
                                        {/* <h2 class="title">About Us</h2> */}
                                        <nav className="breadcrumb">
                                            <span property="itemListElement" typeof="ListItem">
                                                <a href="index.html">Home</a>
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span property="itemListElement" typeof="ListItem">
                                                Event Info
                                            </span>
                                            <span className="breadcrumb-separator">/</span>
                                            <span
                                                className="beadcrumb-active"
                                                property="itemListElement"
                                                typeof="ListItem"
                                            >
                                                Venue Details
                                            </span>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* breadcrumb-area-end */}
                    {/* about-area */}
                    <section className="Venue_section">
                        <div className="container">
                            <div className="row" data-aos="fade-up" data-aos-delay={300}>
                                <div className="col-md-12 text-center">
                                    {/* <h4 class="border_title">Venue</h4> */}
                                    <div className="selector">
                                        <h2 className="ah-headline letters rotate-3">
                                            {/* <p>Conference Organisation</p> */}
                                            <span className="position_relative yellow_color">
                                                VENUE DETAILS
                                            </span>
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt_40">
                                <div
                                    className="col-lg-8 col-sm-12"
                                    data-aos="fade-right"
                                    data-aos-delay={300}
                                >
                                    <div className="venue-content">
                                        <h3 className="mb-0">INDIA ITME 2026</h3>
                                        <p className="mb-30">
                                            4th - 9th December 2026 @ Greater Noida, Uttar Pradesh
                                        </p>
                                        <h5 className="yellow_color">India Exposition Mart Limited</h5>
                                        <p>
                                            Plot No. 23/25, 27/29, Knowledge Park II, Greater Noida, Uttar
                                            Pradesh 201306.
                                        </p>
                                        <h6>“India's Largest Integrated Venue”</h6>
                                        <p>
                                            India Expo Centre &amp; Mart is India's first integrated
                                            international exhibition cum convention centre, featuring a unique
                                            mix of state-of-the-art infrastructure and facilities, which,
                                            along with marts encompasses more than 2,32,000 square meters
                                            area. lt is innovatively designed to offer scale as well as
                                            flexibility in layout &amp; planning. The destination is actively
                                            supported by local authorities and administration.
                                        </p>
                                        <h6>HALL TO SEAT 25,000+ DELEGATES</h6>
                                        <h6>ALLOWS 1,50,000 VISITORS PER DAY</h6>
                                        <p>
                                            India Expo Centre &amp; Mart offers services of the highest
                                            quality, at par with international standards. The permanent
                                            complex offers combinations of conference cum exhibition halls,
                                            meeting places, convention options, outdoors areas - all with
                                            well-appointed facilities, besides the expandable areas, making it
                                            the preferred premier destination for logistically challenging
                                            events; be they international trade fairs &amp; conferences or
                                            huge consumer shows. IEML ensures an all-equipped base for almost
                                            all possible events; be it setting up of security systems for
                                            Heads of State or be it a case of management and controls for
                                            movement of a million visitors.
                                        </p>
                                        <p>
                                            To Know More about Venue{" "}
                                            <a
                                                href="https://itme2022.india-itme.com/pdf/IEML%20INFO%20ITME%202021.pdf"
                                                target="_blank"
                                            >
                                                <span>Click here</span>
                                            </a>
                                        </p>
                                        <h6>Timings:</h6>
                                        <p>
                                            Exhibition will remain open from 9:30 to 18.00 hours on all days.
                                            Exhibitors will be allowed to enter the exhibition halls at 08.30
                                            hours and leave the exhibition halls at 19.00 hours during the
                                            exhibition period to service their stalls. For security reasons,
                                            Exhibitors who want to stay beyond closing time must obtain
                                            permission in advance form the Exhibition Authority.
                                        </p>
                                        <p>
                                            Trade and industry visitors, technicians, technical students, mill
                                            executives, workmen, government representatives, representatives
                                            of financial sector and other visitors are allowed entry on
                                            identity card supplied by the Exhibition Authority from 9.30 hours
                                            to 18.00 hours during the exhibition period.
                                        </p>
                                    </div>
                                </div>
                                <div
                                    className="col-lg-4 col-sm-12"
                                    data-aos="fade-left"
                                    data-aos-delay={300}
                                >
                                    <div className="position_relative f-right text-center">
                                        <div className="venue_img">
                                            <img src="assets/img/map.png" alt="Choose Us" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>

                <Footer />
            </>
        )

    }
}

export default withRouter(connect(null, {})(venueDetails));